export const getGenericDocumentData = {
    source: 'data',
    route: '/document/generic/documents/:documentId/files/:fileId',
    method: 'GET',
};
